import React from 'react'

interface AccessDeniedScreenProps {
  message?: string
  onRetry?: () => void
}

export const AccessDeniedScreen: React.FC<AccessDeniedScreenProps> = ({ 
  message = "У вас нет доступа к системе", 
  onRetry 
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-red-500 via-pink-500 to-rose-600 flex items-center justify-center p-4">
      <div className="bg-white/95 backdrop-blur-sm rounded-3xl p-8 max-w-md w-full text-center shadow-2xl border border-white/20">
        {/* Иконка блокировки */}
        <div className="relative mb-6 flex justify-center">
          <div className="w-20 h-20 bg-gradient-to-br from-red-500 to-pink-600 rounded-full flex items-center justify-center shadow-lg relative">
            {/* Простой красивый крестик */}
            <svg 
              className="w-8 h-8 text-white" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={3} 
                d="M6 18L18 6M6 6l12 12" 
              />
            </svg>
            {/* Упрощенная анимация */}
            <div className="absolute inset-0 rounded-full border-2 border-red-300 animate-pulse opacity-40"></div>
          </div>
        </div>

        {/* Заголовок */}
        <h1 className="text-2xl font-bold text-gray-800 mb-4">
          Доступ ограничен
        </h1>

        {/* Сообщение */}
        <p className="text-gray-600 mb-6 leading-relaxed">
          У вас нет доступа к нашей системе
        </p>

        {/* Информационный блок */}
        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-4 mb-6 border border-blue-100">
          <div className="flex items-start space-x-3">
            <div className="flex-shrink-0">
              <svg 
                className="w-6 h-6 text-blue-500 mt-0.5" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" 
                />
              </svg>
            </div>
            <div className="text-left">
              <h3 className="text-sm font-semibold text-blue-800 mb-1">
                Что делать?
              </h3>
              <p className="text-sm text-blue-700">
                Обратитесь, пожалуйста, к менеджеру, который выдавал вам ранее доступ к системе
              </p>
            </div>
          </div>
        </div>

        {/* Кнопки */}
        <div className="space-y-2">
          {onRetry && (
            <button 
              onClick={onRetry}
              className="w-full bg-gradient-to-r from-red-500 to-pink-600 hover:from-red-600 hover:to-pink-700 text-white font-medium py-2.5 px-4 rounded-lg transition-all duration-200 shadow-md hover:shadow-lg text-sm"
            >
              <span className="flex items-center justify-center space-x-2">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
                <span>Попробовать снова</span>
              </span>
            </button>
          )}
          
          <button 
            onClick={() => {
              // Закрываем Telegram Mini App
              if ((window as any).Telegram?.WebApp?.close) {
                (window as any).Telegram.WebApp.close()
              } else {
                // Fallback для браузера
                window.close()
              }
            }}
            className="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium py-2.5 px-4 rounded-lg transition-all duration-200 border border-gray-200 hover:border-gray-300 text-sm"
          >
            <span className="flex items-center justify-center space-x-2">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
              <span>Закрыть приложение</span>
            </span>
          </button>
        </div>

        {/* Дополнительная информация */}
        <div className="mt-6 pt-4 border-t border-gray-100">
          <p className="text-xs text-gray-500">
            Если проблема повторяется, свяжитесь с технической поддержкой
          </p>
        </div>
      </div>
    </div>
  )
}
